import { slice } from "./slice";
import thunks from "./thunks";

const actions = slice.actions;
const reducer = slice.reducer;

export { actions, reducer, thunks };
